import { useDetailContext } from '../../context/DetailContext';
import { useProducts } from '../../context/ProductContext';
import { useStorageItems } from '../../context/StorageItemsContext';
import { useActivities } from '../../context/ActivitiesContext';
import DetailExtraCard from './Extra/DetailExtraCard';
import DetailProductCard from './Products/DetailProductCard';
import DetailVenueCard from './Venue/DetailVenueCard';
import { useEffect } from 'react';
// Venues sample data
import { venues } from '../../constants/venues';
import DetailActivityCard from './Activity/DetailActivityCard';
import { log } from "../../utils/logger";
/**
* Detail card renderer.
* Renders differrent card based on type of the product
*
* @returns TSX.Element
*/
export const DetailCardRenderer = () => {
    const {openedDetailCard} = useDetailContext(); // Detail context

    const { allProducts, loading, reloadProducts, packages } = useProducts() // Products
    const { items, reloadItems, loading: loadingItems } = useStorageItems(); // Storage items
    const { activities, reloadActivities, loading: loadingActivities } = useActivities();
    // Reload products if they are loaded but dont appear
    useEffect(() => {
        if (!loading && !allProducts) {
            reloadProducts();
        }
        if (!loadingItems && !items) {
            reloadItems();
        }
        if (!loadingActivities && !activities) {
            reloadActivities();
        }
    },[loading, loadingItems, loadingActivities])



    return(
        <>
            {openedDetailCard && (() => {
                const {id, type, time, date} = openedDetailCard;
                // Find the product by id 
                switch (type) {
                    case 'sales': {
                        const product = allProducts.find(p => p.id === id);
                        if (!product) return null;
                        return (
                            <DetailProductCard
                                product={product}
                                time={time}
                                date={date}
                            />
                        );
                    }
                    case 'new': {
                        const product = allProducts.find(p => p.id === id);
                        if (!product) return null;
                        return (
                            <DetailProductCard
                                product={product}
                                time={time}
                                date={date}
                            />
                        );
                    }
                    case 'package': {
                        const product = packages.find(p => p.id === id);
                        if (!product) return null;
                        return (
                            <DetailProductCard
                                product={product}
                                type="package"
                            />
                        );
                    }
                    case 'storage': {
                        const extra = items.find(p => p.id === id);
                        if (!extra) return null;
                        return (
                            <DetailExtraCard
                                product={extra}
                                time={time}
                                date={date}
                            />
                        );
                    }
                    case 'activities': {
                        const activity = activities.find(p => p.id === id);
                        //log(activity)
                        if (!activity) return null;
                        return (
                            <DetailActivityCard
                                product={activity}
                                time={time}
                                date={date}
                            />
                        );
                    }
                    case 'venue': {
                        const venue = venues.find(p => p.id === id);
                        if (!venue) return null;
                        return (
                            <DetailVenueCard
                                {...venue}
                            />
                        );
                    }
                default:
                return null;
            }
            })()}
        </>
    )
}
